import { render, staticRenderFns } from "./order-constructopr-header.vue?vue&type=template&id=817133c6&"
import script from "./order-constructopr-header.vue?vue&type=script&lang=ts&"
export * from "./order-constructopr-header.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports